import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    visible: { type: Boolean, default: false },
    title: { default: '异形选刀提示' },
    data: { default: () => [] },
    showViewBtn: { type: Boolean }
  },
  emits: ["update:visible", "ok"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', val: boolean): void
  (e: 'ok'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, title: any, data: Array<{
      stockNum: number
      tips: string
    }>, showViewBtn?: boolean }





const visible = computed({
  get() {
    return props.visible
  },
  set(val) {
    emit('update:visible', val)
    return true
  },
})

const confirmLoading = ref(false)
const handleOk = () => {
  visible.value = false
  emit('ok')
}

// 关闭弹窗
const handleCancel = () => {
  visible.value = false
}

return { __sfc: true,props, emit, visible, confirmLoading, handleOk, handleCancel }
}

})